import React, { useEffect, useState } from "react";
import supabase from "../../../../conndb";
import NavabarGest from "./navabarGes";
import Loader from "./loader";
export default function Ins_interventi() {
  const [clienti, setClienti] = useState([]);
  const [searchCliente, setSearchCliente] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [dispositivi, setDispositivi] = useState([]);
  const [tipoIntervento, setTipoIntervento] = useState("stufa");
  const [selectedDispositivo, setSelectedDispositivo] = useState(null);
  const [dataIntervento, setDataIntervento] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const [inserito, setInserito] = useState(false);
  const [showClientiList, setShowClientiList] = useState(false);

  // Recupera tutti i clienti
  const fetchClienti = async () => {
    const { data, error } = await supabase.from("clienti").select("*");
    if (error) console.error(error);
    else setClienti(data);
    setLoading(false);
  };

  // Recupera dispositivi del cliente selezionato
  const fetchDispositivi = async (clienteId) => {
    if (!clienteId) return;
    let table = tipoIntervento === "stufa" ? "stufe" : "caldaie";
    const { data, error } = await supabase
      .from(table)
      .select("*")
      .eq("cliente_id", clienteId);
    if (error) console.error(error);
    else setDispositivi(data);
  };

  useEffect(() => {
    fetchClienti();
  }, []);

  useEffect(() => {
    if (selectedCliente) {
      fetchDispositivi(selectedCliente.id);
      setSelectedDispositivo(null);
    }
  }, [selectedCliente, tipoIntervento]);

  // Inserisce intervento
  const handleInserisciIntervento = async () => {
    if (!selectedCliente || !selectedDispositivo || !dataIntervento) {
      alert("Seleziona cliente, dispositivo e data!");
      return;
    }

    const table = tipoIntervento === "stufa" ? "interventi_stufe" : "interventi_caldaie";

    const { error } = await supabase.from(table).insert([
      {
        cliente_id: selectedCliente.id,
        [`${tipoIntervento}_id`]: selectedDispositivo.id,
        data: dataIntervento,
        note: note
      }
    ]);

    if (error) console.error(error);
    else {
      setInserito(true);
      setSelectedCliente(null);
      setSelectedDispositivo(null);
      setTipoIntervento("stufa");
      setDataIntervento("");
      setNote("");
      setDispositivi([]);
      setSearchCliente("");
      setShowClientiList(false);
    }
  };

  // Filtra clienti
  const filteredClienti = searchCliente
    ? clienti.filter((c) =>
        `${c.nome} ${c.cognome}`.toLowerCase().includes(searchCliente.toLowerCase())
      )
    : clienti;

  if (loading) return <Loader></Loader>;

  return (
    <div className="p-6 bg-[#173341] min-h-screen">
      <NavabarGest />
      <div className="bg-[#5b90ab70] rounded-2xl p-8 text-white">
      <h1 className="text-3xl text-white text-center font-bold mb-4">Inserisci Intervento</h1>

      {/* Barra di ricerca */}
      <input
        type="text"
        placeholder="Cerca cliente..."
        value={searchCliente}
        onChange={(e) => {
          setSearchCliente(e.target.value);
          setShowClientiList(true);
        }}
        onFocus={() => setShowClientiList(true)}
        className="mb-2 p-2 bg-[#173341] rounded w-full "
      />

      {/* Lista clienti (visibile solo se showClientiList è true) */}
      {showClientiList && (
        <div className="bg-[#173341] rounded mb-4 max-h-40 overflow-y-auto">
          {filteredClienti.map((c) => (
            <div
              key={c.id}
              onClick={() => {
                setSelectedCliente(c);
                setSearchCliente(`${c.nome} ${c.cognome}`);
                setShowClientiList(false);
              }}
              className={`p-2 cursor-pointer hover:bg-gray-400 ${
                selectedCliente?.id === c.id ? "bg-green-600" : ""
              }`}
            >
              {c.nome} {c.cognome}
            </div>
          ))}
        </div>
      )}

      {/* Tipo intervento */}
      <div className="mb-2">
        <label className="mr-2">Tipo intervento:</label>
        <select
          value={tipoIntervento}
          onChange={(e) => setTipoIntervento(e.target.value)}
          className="p-2 rounded bg-[#173341]"
        >
          <option value="stufa">Stufa</option>
          <option value="caldaia">Caldaia</option>
        </select>
      </div>

      {/* Select dispositivo */}
      {selectedCliente && (
        <div className="mb-2">
          <label className="mr-2">Dispositivo:</label>
          <select
            value={selectedDispositivo?.id || ""}
            onChange={(e) =>
              setSelectedDispositivo(
                dispositivi.find((d) => d.id === parseInt(e.target.value))
              )
            }
            className="p-2 bg-[#173341] rounded w-full"
          >
            <option value="">Seleziona dispositivo</option>
            {dispositivi.map((d) => (
              <option key={d.id} value={d.id}>
                {d.matricola} - {d.modello}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Data intervento */}
      <div className="mb-2">
        <label className="mr-2">Data intervento:</label>
        <input
          type="date"
          value={dataIntervento}
          onChange={(e) => setDataIntervento(e.target.value)}
          className="p-2 bg-[#173341] rounded w-full"
        />
      </div>

      {/* Note */}
      <div className="mb-4">
        <label className="mr-2">Note:</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="p-2 bg-[#173341] rounded w-full"
        ></textarea>
      </div>
      <div className="text-center">
        {/* Pulsante inserisci */}
          <button
            onClick={handleInserisciIntervento}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Inserisci Intervento
          </button>
      </div>
      {inserito && <p className="mt-2 text-green-600">Intervento inserito con successo!</p>}
      </div>
    </div>
  );
}
